import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const CastingCreate = () => {
  const navigate = useNavigate();

  const [castingData, setCastingData] = useState({
    company: "",
    machineModel: "",
    client: "",
    machineForm: "",
    dataId: "",
    measurementTime: ""
  });

  const handleFileChange = async (e, fileKey) => {
    const file = e.target.files[0];
    try {
      const imageData = await convertToBase64(file);
      setCastingData((prev) => ({ ...prev, [fileKey]: imageData }));
      console.log("Converted Image Data:", castingData);
    } catch (error) {
      console.error("Error converting file:", error);
    }
  };

  const onCastingManagement = (e) => {
    e.preventDefault();
    navigate('/casting-management');
  };

  const onCastingFRF = (e) => {
    e.preventDefault();
    //alert("已儲存變更");
    console.log('基本資料傳遞', castingData);
    localStorage.setItem("castingData", JSON.stringify(castingData));
    navigate('/casting-frequency-response-function', { state: { castingData } });
  };

  useEffect(() => {
    const savedData = localStorage.getItem("KeepData");
    if (savedData) {
      setCastingData(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    const savedData = localStorage.getItem("castingData");
    if (savedData) {
      setCastingData(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("castingData", JSON.stringify(castingData));
  }, [castingData]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("castingData");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve({ image: reader.result });
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        reject(error);
      };
    });
  };

  const handleChange = (event) => {
    const { id, value } = event.target;
    setCastingData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  return (
    <div className="d-flex" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" >
              <a href="#" onClick={onCastingManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>鑄件資料庫</a>
            </li>
            <li
              className="breadcrumb-item"
              aria-current="page"
              style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>新增資料
            </li>
          </ol>
        </nav>

        <div style={{ height: '10px', width: '100%' }}></div>

        <form >
          <div className=" d-flex flex-column">
            <span className="sub-title">基本資料</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="company" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>鑄件</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="company" value={castingData.company} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="client" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>料號</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="client" value={castingData.client} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="dataId" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>資料ID</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="dataId" value={castingData.dataId} onChange={handleChange} />
                  </div>
                </div>
              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="machineModel" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>機台型號</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineModel" value={castingData.machineModel} onChange={handleChange} />
                  </div>
                </div>

                <div className=" row mb-3">
                  <label htmlFor="machineForm" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>機台型式</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineForm" value={castingData.machineForm} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="measurementTime" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "100px" }}>測量時間</label>
                  <div className="col-sm-9">
                    <input type="datetime-local" className="form-control" id="measurementTime" value={castingData.measurementTime} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: '40px', width: '100%' }}></div>
            <span className="sub-title">測量記錄</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_1" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>量測點位</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_1" accept="image/*" onChange={(e) => handleFileChange(e, 'measurementPointFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_2" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>敲擊位置</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_2" accept="image/*" onChange={(e) => handleFileChange(e, 'impactPositionFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_3" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>機台型式</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_3" accept="image/*" onChange={(e) => handleFileChange(e, 'machineImageFile')} />
              </div>
            </div>
          </div>

          <div style={{ height: '15px', width: '100%' }}></div>

          <div className="d-flex justify-content-end gap-3" style={{ paddingRight: "60px" }}>
            <button
              className="btn-cancel"
              style={{ height: '35px', width: '60px' }}
              onClick={onCastingManagement}
              type="button"
            >
              取消
            </button>
            <button
              className="btn-confirm btn-primary"
              style={{ height: '35px', width: '60px' }}
              onClick={onCastingFRF}
              type="button"
            >
              下一步
            </button>
          </div>
          <div style={{ height: '60px', width: '100%' }}></div>
        </form>
      </div>
    </div>
  );
};

export default CastingCreate;